import {
	MonitorSettingsBase, MonitorSettingsEntry,
	MonitorSettingsFactory, MonitorSettingsEntryFactory
} from "./MonitorSettings";
import { MonitorSettings_Ping, MonitorSettings_IpEntry } from "./MonitorSettings_Ping";
import { MonitorSettings_SnmpIf, MonitorSettings_SnmpIfEntry } from "./MonitorSettings_SnmpIf";
import { MonitorType } from "../Core/MonitorType";
import { MonitorSettings_Config, MonitorSettings_PRTG } from ".";
import { MonitorSettings_ConfigEntry } from "./MonitorSettings_Config";
import { MonitorSettings_Snmp, SnmpMonitorEntry } from "./MonitorSettings_Snmp";


export class DefaultMonitorSettingsFactory implements MonitorSettingsFactory {

	static Initialize(): void {
		if (!MonitorSettingsBase.Factory) {
			MonitorSettingsBase.Factory = new DefaultMonitorSettingsFactory();
		}
	}

	public CreateMonitorSettings(monitorType: MonitorType): MonitorSettingsBase {
		let newSettings: MonitorSettingsBase = null;

		switch (monitorType) {
			case MonitorType.Ping:
				newSettings = new MonitorSettings_Ping();
				break;

			case MonitorType.SNMP_Interface:
				newSettings = new MonitorSettings_SnmpIf();
				break;

			case MonitorType.Config:
				newSettings = new MonitorSettings_Config();
				break;

			case MonitorType.SNMP:
				newSettings = new MonitorSettings_Snmp();
				break;

			case MonitorType.PRTG:
				newSettings = new MonitorSettings_PRTG();
				break;

			default:
				console.assert(false, "Unsupported monitor type: " + monitorType);
				newSettings = null;
				break;
		}

		return newSettings;
	}
}
DefaultMonitorSettingsFactory.Initialize();


export class DefaultMonitorSettingsEntryFactory implements MonitorSettingsEntryFactory {

	static Initialize(): void {
		if (!MonitorSettingsEntry.Factory) {
			MonitorSettingsEntry.Factory = new DefaultMonitorSettingsEntryFactory();
		}
	}

	public CreateMonitorSettingsEntry(monitorType: MonitorType): MonitorSettingsEntry {
		let newSettingsEntry: MonitorSettingsEntry = null;

		switch (monitorType) {
			case MonitorType.Ping:
				newSettingsEntry = new MonitorSettings_IpEntry();
				break;

			case MonitorType.SNMP_Interface:
				newSettingsEntry = new MonitorSettings_SnmpIfEntry();
				break;

			case MonitorType.Config:
				newSettingsEntry = new MonitorSettings_ConfigEntry();
				break;

			case MonitorType.SNMP:
				newSettingsEntry = new SnmpMonitorEntry();
				break;

			default:
				console.assert(false, "Unsupported monitor type: " + monitorType);
				newSettingsEntry = null;
				break;
		}

		return newSettingsEntry;
	}
}
DefaultMonitorSettingsEntryFactory.Initialize();
